jQuery(document).ready(function($){
    if ( $('.nf-insights-slider') ) {
        $('.nf-insights-slider').slick({
            slidesToScroll: 1,
            slidesToShow: 2,
            prevArrow: '<button class="slick-arrow prev"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none"><path d="M6.5 17.2598L7.925 15.8581L5.825 13.7554H21V11.7529H5.825L7.9 9.65029L6.475 8.24854L2 12.7542L6.5 17.2598Z" fill="#fff"/></svg></button>',
            nextArrow: '<button class="slick-arrow next"><span>More Featured Articles</span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none"><path d="M17.5 17.2598L16.075 15.8581L18.175 13.7554H3V11.7529H18.175L16.1 9.65029L17.525 8.24854L22 12.7542L17.5 17.2598Z" fill="#fff"/></svg></button>',
            appendArrows: $('.nf-insights-slider__nav'),
            variableWidth: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 1,
                        variableWidth: false,
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                        variableWidth: false,
                        fade: true,
                    }
                }
            ]
        });
    }
});